export default {
  showStages: 'Show stages',
};
